import React, { Component } from 'react';
import language from '../../assets/languages/language';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import App_data from '../config/App_data';

class CBTNonAttempted extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  pdfAlertModel = (e) => {
    e.preventDefault();
    this.props.pdfAlertModel(e);
  };

  render() {
    const { handleClose, showFinishTestPopup, submitTest } = this.props;
    return (
      <Modal
        isOpen={showFinishTestPopup}
        toggle={handleClose}
        className={
          'modal-primary custom_modalpro info-modal-designing' +
          this.props.className
        }
      >
        {/* question mark */}
        <ModalHeader toggle={handleClose} className='custom-title'>
          <i className='fa fa-info-circle' aria-hidden='true' />{' '}
          {language.LC().Finish_Test}
        </ModalHeader>
        <ModalBody className='text-center'>
          <div className='modal-info-view-for-plan '>
            <img
              className='mb-2'
              width='70'
              src={App_data.frontend_url + '/img/questions/icon_triangle.png'}
              alt='Question'
            />
            <p className='model-big-text'>
              {language.LC().NOT_ATTEMPTED_POPUP}
            </p>
            <p className='model-big-text'>
              {language.LC().ARE_YOU_SURE_FINISH}
            </p>

            <div className='btn-plan-view view-plan-wrap'>
              <Button className='btn btn-primary m-lr-10' onClick={submitTest}>
                {language.LC().SUBMIT}
              </Button>
              <Button
                className='btn btn-primary  m-lr-10'
                onClick={handleClose}
              >
                Cancel
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default CBTNonAttempted;



// WEBPACK FOOTER //
// ./src/views/Common/CBTNonAttempted.js